import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import {
  ContentCard,
  CardTitle,
  FormGrid,
  FormGroup,
  ActionButtons,
  SaveButton,
  SuccessMessage,
  ErrorMessage
} from '../styles/AdminStyles';

const ContactEditor = () => {
  const [contactData, setContactData] = useState({
    address: '',
    phone: '',
    email: '',
    hours: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchContactContent();
  }, []);

  const fetchContactContent = async () => {
    try {
      const data = await apiService.getContactContent();
      setContactData({
        address: data.address || '',
        phone: data.phone || '',
        email: data.email || '',
        hours: data.hours || 'Monday - Friday: 8:00 AM - 6:00 PM' // Default value if not in database
      });
    } catch (error) {
      console.error('Error fetching contact content:', error);
      setMessage({ 
        type: 'error', 
        text: 'Failed to load contact information. Please try again.' 
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage(null);
    
    try {
      await apiService.updateContactContent(contactData);
      setMessage({ type: 'success', text: 'Contact information updated successfully!' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Error updating contact information. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentCard>
      <CardTitle>Contact Information</CardTitle>
      
      {message && (
        message.type === 'success' ? (
          <SuccessMessage>{message.text}</SuccessMessage>
        ) : (
          <ErrorMessage>{message.text}</ErrorMessage>
        )
      )}
      
      <FormGrid>
        <FormGroup>
          <label htmlFor="address">Address</label>
          <input
            type="text"
            id="address"
            name="address"
            value={contactData.address}
            onChange={handleInputChange}
            placeholder="Enter company address"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <label htmlFor="phone">Phone</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={contactData.phone}
            onChange={handleInputChange}
            placeholder="Enter contact phone number"
            required
          />
        </FormGroup>
      </FormGrid>
      
      <FormGrid>
        <FormGroup>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={contactData.email}
            onChange={handleInputChange}
            placeholder="Enter contact email address"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <label htmlFor="hours">Business Hours</label>
          <input
            type="text"
            id="hours"
            name="hours"
            value={contactData.hours}
            onChange={handleInputChange}
            placeholder="Enter business hours"
          />
        </FormGroup>
      </FormGrid>
      
      <ActionButtons>
        <SaveButton onClick={handleSave} disabled={loading}>
          {loading ? 'Saving...' : 'Save Changes'}
        </SaveButton>
      </ActionButtons>
    </ContentCard>
  );
};

export default ContactEditor;
